import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer'
import { generateAssessmentId } from '../utils/idGenerator'

// CEDEC Brand Colors and Styles - Redesigned for better page breaks
const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#ffffff',
    padding: 40,
    paddingBottom: 60,
    fontFamily: 'Helvetica'
  },
  
  // Header Styles
  header: {
    marginBottom: 25,
    paddingBottom: 15,
    borderBottomWidth: 3,
    borderBottomColor: '#2c5aa0',
    alignItems: 'center'
  },
  logoImage: {
    width: 120,
    height: 'auto',
    marginBottom: 12,
    objectFit: 'contain'
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#2c5aa0',
    marginBottom: 4
  },
  subtitle: {
    fontSize: 11,
    color: '#666666',
    marginBottom: 2
  },
  
  // Client Info Box
  clientInfo: {
    backgroundColor: '#f8f9fa',
    padding: 12,
    marginBottom: 20,
    borderLeftWidth: 4,
    borderLeftColor: '#2c5aa0'
  },
  clientName: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#333333',
    marginBottom: 4
  },
  clientDetails: {
    fontSize: 10,
    color: '#666666',
    marginBottom: 2
  },
  
  // Section Styles
  section: {
    marginBottom: 20
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#2c5aa0',
    marginBottom: 12,
    paddingBottom: 4,
    borderBottomWidth: 2,
    borderBottomColor: '#2c5aa0'
  },
  
  // Score Cards
  scoreRow: {
    flexDirection: 'row',
    marginBottom: 15,
    gap: 10
  },
  scoreCard: {
    flex: 1,
    backgroundColor: '#f8f9fa',
    padding: 12,
    borderLeftWidth: 4,
    borderLeftColor: '#2c5aa0',
    alignItems: 'center'
  },
  scoreValue: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#2c5aa0',
    marginBottom: 4
  },
  scoreLabel: {
    fontSize: 9,
    color: '#666666',
    textAlign: 'center'
  },
  
  
  // Theme/Domain Rows
  themeRow: {
    flexDirection: 'row',
    paddingVertical: 6,
    paddingHorizontal: 10,
    marginBottom: 4,
    backgroundColor: '#f8f9fa',
    alignItems: 'center'
  },
  themeName: {
    flex: 1,
    fontSize: 10,
    color: '#333333'
  },
  themeScore: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#2c5aa0',
    marginRight: 8,
    minWidth: 35,
    textAlign: 'right'
  },
  statusBadge: {
    paddingHorizontal: 6,
    paddingVertical: 3,
    borderRadius: 8,
    minWidth: 75,
    textAlign: 'center'
  },
  statusText: {
    fontSize: 8,
    fontWeight: 'bold',
    color: '#ffffff'
  },
  
  // Action Items
  actionItem: {
    marginBottom: 8,
    paddingBottom: 8,
    borderBottomWidth: 1,
    borderBottomColor: '#e9ecef'
  },
  actionHeader: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 3
  },
  actionNumber: {
    width: 18,
    height: 18,
    borderRadius: 9,
    backgroundColor: '#2c5aa0',
    color: '#ffffff',
    fontSize: 9,
    textAlign: 'center',
    lineHeight: 1.8,
    marginRight: 8,
    fontWeight: 'bold'
  },
  actionTitle: {
    flex: 1,
    fontSize: 11,
    fontWeight: 'bold',
    color: '#333333'
  },
  actionDescription: {
    fontSize: 9,
    color: '#666666',
    marginLeft: 26,
    lineHeight: 1.3
  },
  
  // Question Details
  questionBox: {
    marginBottom: 12,
    paddingBottom: 10,
    borderBottomWidth: 1,
    borderBottomColor: '#e9ecef'
  },
  questionNumber: {
    fontSize: 8,
    color: '#666666',
    marginBottom: 2,
    textTransform: 'uppercase'
  },
  questionText: {
    fontSize: 10,
    color: '#333333',
    marginBottom: 4,
    lineHeight: 1.4
  },
  answerRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 4
  },
  answerLabel: {
    fontSize: 9,
    color: '#666666',
    marginRight: 8
  },
  answerValue: {
    fontSize: 11,
    fontWeight: 'bold',
    color: '#2c5aa0',
    marginRight: 8
  },
  answerStatus: {
    fontSize: 8,
    paddingHorizontal: 6,
    paddingVertical: 2,
    borderRadius: 4,
    color: '#ffffff'
  },
  
  // Recommendation Boxes
  recBox: {
    backgroundColor: '#e3f2fd',
    padding: 10,
    marginBottom: 8,
    borderLeftWidth: 3,
    borderLeftColor: '#1976d2'
  },
  recTitle: {
    fontSize: 11,
    fontWeight: 'bold',
    color: '#1976d2',
    marginBottom: 4
  },
  recText: {
    fontSize: 9,
    color: '#333333',
    lineHeight: 1.4
  },
  
  // Contact Box
  contactBox: {
    backgroundColor: '#2c5aa0',
    padding: 12,
    marginTop: 15
  },
  contactTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#ffffff',
    marginBottom: 8,
    textAlign: 'center'
  },
  contactText: {
    fontSize: 9,
    color: '#ffffff',
    marginBottom: 2,
    textAlign: 'center'
  },
  
  // Footer
  footer: {
    position: 'absolute',
    bottom: 20,
    left: 40,
    right: 40,
    paddingTop: 10,
    borderTopWidth: 1,
    borderTopColor: '#e9ecef',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  footerText: {
    fontSize: 8,
    color: '#999999'
  },
  
  // Utility
  urgentBanner: {
    backgroundColor: '#dc3545',
    padding: 10,
    marginBottom: 15,
    textAlign: 'center'
  },
  urgentText: {
    fontSize: 11,
    fontWeight: 'bold',
    color: '#ffffff'
  }
})

/**
 * Get status information based on score
 */
const getStatusFromScore = (score) => {
  if (score <= 2) return { color: '#dc3545', text: 'CRITIQUE' }
  if (score <= 5) return { color: '#fd7e14', text: 'À AMÉLIORER' }
  if (score <= 7) return { color: '#ffc107', text: 'SATISFAISANT' }
  if (score <= 9) return { color: '#28a745', text: 'BON' }
  return { color: '#198754', text: 'EXCELLENCE' }
}

/**
 * Redesigned CEDEC PDF Report Component
 * Clean, professional layout with detailed question pages
 */
const CEDECReport = ({ clientInfo, assessmentData, recommendations }) => {
  const scores = Object.values(assessmentData.scores || {}).filter(score => score !== null && score !== undefined)
  const averageScore = scores.length > 0 ? (scores.reduce((a, b) => a + b, 0) / scores.length) : 0
  const reportId = generateAssessmentId(clientInfo)
  
  // Calculate theme averages
  const themeAverages = assessmentData.themes?.map(theme => {
    const themeQuestionScores = theme.questions
      .map(q => assessmentData.scores[q.id])
      .filter(score => score !== null && score !== undefined)
    
    return themeQuestionScores.length > 0 
      ? themeQuestionScores.reduce((sum, score) => sum + score, 0) / themeQuestionScores.length 
      : 0
  }) || []

  return (
    <Document 
      title={`Rapport CEDEC - ${clientInfo.company}`} 
      creator="CEDEC" 
      producer="CEDEC Assessment Tool"
    >
      {/* ========== PAGE 1: EXECUTIVE SUMMARY + THEME ANALYSIS ========== */}
      <Page size="A4" style={styles.page} wrap>
        {/* Header */}
        <View style={styles.header} fixed>
          <Image 
            src="https://cedecfrblob.blob.core.windows.net/public/Cedec-logo-nosub%20(1).png?sp=r&st=2025-10-01T20:52:55Z&se=2035-10-02T05:07:55Z&spr=https&sv=2024-11-04&sr=b&sig=Tuc%2B%2F4KITu7WsV%2BBY%2FAciyNhGxVOdoumFoSNH39Azqs%3D"
            style={styles.logoImage}
          />
          <Text style={styles.title}>Rapport Score de Résilience</Text>
          <Text style={styles.subtitle}>Évaluation approfondie accompagnée</Text>
          <Text style={styles.subtitle}>Rapport N° {reportId}</Text>
        </View>

        {/* Urgent Banner */}
        {recommendations?.urgencyLevel?.level === 'CRITIQUE' && (
          <View style={styles.urgentBanner} wrap={false}>
            <Text style={styles.urgentText}>
              SITUATION CRITIQUE - {recommendations.urgencyLevel.action}
            </Text>
          </View>
        )}

        {/* Client Info */}
        <View style={styles.clientInfo} wrap={false}>
          <Text style={styles.clientName}>
            {clientInfo.firstName} {clientInfo.lastName}
          </Text>
          <Text style={styles.clientDetails}>Entreprise: {clientInfo.company}</Text>
          <Text style={styles.clientDetails}>N° Dossier: {clientInfo.clientId || 'N/A'}</Text>
          <Text style={styles.clientDetails}>Email: {clientInfo.email}</Text>
          {clientInfo.phone && (
            <Text style={styles.clientDetails}>Téléphone: {clientInfo.phone}</Text>
          )}
          <Text style={styles.clientDetails}>
            Date d'évaluation: {new Date().toLocaleDateString('fr-FR')}
          </Text>
        </View>

        {/* Executive Summary */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Résumé Exécutif</Text>
          
          {/* Score Cards */}
          <View style={styles.scoreRow} wrap={false}>
            <View style={styles.scoreCard}>
              <Text style={styles.scoreValue}>{averageScore.toFixed(1)}</Text>
              <Text style={styles.scoreLabel}>Score Moyen</Text>
            </View>
            <View style={styles.scoreCard}>
              <Text style={styles.scoreValue}>
                {recommendations?.overview?.criticalCount?.toString() || '0'}
              </Text>
              <Text style={styles.scoreLabel}>Thèmes Critiques</Text>
            </View>
            <View style={styles.scoreCard}>
              <Text style={styles.scoreValue}>
                {recommendations?.overview?.strongCount?.toString() || '0'}
              </Text>
              <Text style={styles.scoreLabel}>Thèmes Forts</Text>
            </View>
          </View>
        </View>

        {/* Theme Analysis (moved from page 2 to page 1) */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Analyse par Thème</Text>
          {assessmentData.themes?.map((theme, index) => {
            const themeAverage = themeAverages[index] || 0
            const status = getStatusFromScore(themeAverage)
            const completedQuestions = theme.questions.filter(q => 
              assessmentData.scores[q.id] !== null && assessmentData.scores[q.id] !== undefined
            ).length
            
            return (
              <View key={theme.id} style={styles.themeRow} wrap={false}>
                <Text style={styles.themeName}>
                  {theme.title} ({completedQuestions}/{theme.questions.length})
                </Text>
                <Text style={styles.themeScore}>{themeAverage.toFixed(1)}/10</Text>
                <View style={{ ...styles.statusBadge, backgroundColor: status.color }}>
                  <Text style={styles.statusText}>{status.text}</Text>
                </View>
              </View>
            )
          })}
        </View>

        {/* Footer */}
        <View style={styles.footer} fixed>
          <Text style={styles.footerText}>
            Rapport généré le {new Date().toLocaleDateString('fr-FR')} par CEDEC
          </Text>
          <Text style={styles.footerText}>
            {clientInfo.company} - Confidentiel
          </Text>
        </View>
      </Page>

      {/* ========== DETAILED QUESTIONS - ALL THEMES CONTINUOUS ========== */}
      <Page size="A4" style={styles.page} wrap>
        {/* All themes flow continuously, only break between themes */}
        {assessmentData.themes?.map((theme, themeIndex) => (
          <View key={`theme-detail-${theme.id}`} style={styles.section} wrap={false}>
            {/* Theme Header */}
            <Text style={styles.sectionTitle}>
              {theme.title}
            </Text>
            <Text style={{...styles.clientDetails, marginBottom: 15}}>
              Score moyen: {themeAverages[themeIndex]?.toFixed(1) || '0.0'}/10
            </Text>

            {/* Questions and Answers */}
            {theme.questions.map((question, qIndex) => {
              const score = assessmentData.scores[question.id]
              const status = score !== null && score !== undefined ? getStatusFromScore(score) : null
              
              return (
                <View key={question.id} style={styles.questionBox}>
                  <Text style={styles.questionNumber}>
                    Question {qIndex + 1} / {theme.questions.length}
                  </Text>
                  <Text style={styles.questionText}>
                    {question.title}
                  </Text>
                  {score !== null && score !== undefined ? (
                    <View style={styles.answerRow}>
                      <Text style={styles.answerLabel}>Réponse:</Text>
                      <Text style={styles.answerValue}>{score}/10</Text>
                      {status && (
                        <View style={{ ...styles.answerStatus, backgroundColor: status.color }}>
                          <Text style={{ fontSize: 8, color: '#ffffff' }}>{status.text}</Text>
                        </View>
                      )}
                    </View>
                  ) : (
                    <Text style={{...styles.answerLabel, fontStyle: 'italic'}}>
                      Non répondu
                    </Text>
                  )}
                </View>
              )
            })}
          </View>
        ))}

        {/* Footer */}
        <View style={styles.footer} fixed>
          <Text style={styles.footerText}>
            Rapport généré le {new Date().toLocaleDateString('fr-FR')} par CEDEC
          </Text>
          <Text style={styles.footerText}>
            {clientInfo.company} - Confidentiel
          </Text>
        </View>
      </Page>

      {/* ========== LAST PAGE: CONTACT & NEXT STEPS ========== */}
      <Page size="A4" style={styles.page} wrap>
        {/* Next Steps */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Prochaines Étapes</Text>
          <View style={styles.recBox} wrap={false}>
            <Text style={styles.recTitle}>Recommandations et Plan d'Action</Text>
            <Text style={styles.recText}>
              Votre consultant CEDEC définira avec vous les recommandations et le plan d'action adapté à votre situation.
            </Text>
          </View>
        </View>

        {/* Contact Consultant */}
        <View style={styles.contactBox} wrap={false}>
          <Text style={styles.contactTitle}>
            Votre Consultant CEDEC
          </Text>
          {clientInfo.consultantEmail ? (
            <>
              <Text style={styles.contactText}>Email: {clientInfo.consultantEmail}</Text>
            </>
          ) : (
            <>
              <Text style={styles.contactText}>Email: contact@cedec.eu</Text>
            </>
          )}
        </View>

        {/* Footer */}
        <View style={styles.footer} fixed>
          <Text style={styles.footerText}>
            Rapport généré le {new Date().toLocaleDateString('fr-FR')} par CEDEC
          </Text>
          <Text style={styles.footerText}>
            {clientInfo.company} - Confidentiel
          </Text>
        </View>
      </Page>
    </Document>
  )
}

export default CEDECReport
